import { render, staticRenderFns } from "./DodajStranko.vue?vue&type=template&id=2f43ee04&"
import script from "./DodajStranko.vue?vue&type=script&lang=js&"
export * from "./DodajStranko.vue?vue&type=script&lang=js&"
import style0 from "./DodajStranko.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports